module.exports = __webpack_public_path__ + "static/media/certificate1.b991f324.png";